"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Homography = void 0;
var tslib_1 = require("tslib");
var Matrix = tslib_1.__importStar(require("./matrix"));
var util_1 = require("./util");
var HOMO_COUNT = 4;
var Homography = /** @class */ (function () {
    function Homography() {
    }
    /**
     * Create a homography matrix give a collection of points on the Image plane, and their mappings on the Measurement plane
     *
     * @param alignmentGrid_IP Alignment Grid coordiantes on the image plane
     * @param alignmentGrid_MP Alignment grid coordiantes on the measurement plane
     * @returns {number[]} Homography matrix
     */
    Homography.create = function (alignmentGrid_IP, alignmentGrid_MP) {
        return homography(alignmentGrid_IP, alignmentGrid_MP);
    };
    return Homography;
}());
exports.Homography = Homography;
// Taken from http://inspirit.github.io/jsfeat/ (MIT)
function homography(from, to) {
    var T0 = Matrix.create(3, 3);
    var T1 = Matrix.create(3, 3);
    var mLtL = Matrix.create(9, 9);
    var Evec = Matrix.create(9, 9);
    var i = 0;
    var j = 0;
    var md = Matrix.create(3, 3);
    var x = 0.0;
    var y = 0.0;
    var X = 0.0;
    var Y = 0.0;
    // norm
    var smx = 0.0;
    var smy = 0.0;
    var cmx = 0.0;
    var cmy = 0.0;
    var sMx = 0.0;
    var sMy = 0.0;
    var cMx = 0.0;
    var cMy = 0.0;
    for (; i < HOMO_COUNT; ++i) {
        cmx += to[i].x;
        cmy += to[i].y;
        cMx += from[i].x;
        cMy += from[i].y;
    }
    cmx /= HOMO_COUNT;
    cmy /= HOMO_COUNT;
    cMx /= HOMO_COUNT;
    cMy /= HOMO_COUNT;
    for (i = 0; i < HOMO_COUNT; ++i) {
        smx += Math.abs(to[i].x - cmx);
        smy += Math.abs(to[i].y - cmy);
        sMx += Math.abs(from[i].x - cMx);
        sMy += Math.abs(from[i].y - cMy);
    }
    if (Math.abs(smx) < util_1.EPSILON
        || Math.abs(smy) < util_1.EPSILON
        || Math.abs(sMx) < util_1.EPSILON
        || Math.abs(sMy) < util_1.EPSILON) {
        return null;
    }
    smx = HOMO_COUNT / smx;
    smy = HOMO_COUNT / smy;
    sMx = HOMO_COUNT / sMx;
    sMy = HOMO_COUNT / sMy;
    T0[0] = sMx;
    T0[1] = 0;
    T0[2] = -cMx * sMx;
    T0[3] = 0;
    T0[4] = sMy;
    T0[5] = -cMy * sMy;
    T0[6] = 0;
    T0[7] = 0;
    T0[8] = 1;
    T1[0] = 1.0 / smx;
    T1[1] = 0;
    T1[2] = cmx;
    T1[3] = 0;
    T1[4] = 1.0 / smy;
    T1[5] = cmy;
    T1[6] = 0;
    T1[7] = 0;
    T1[8] = 1;
    //
    // construct system
    i = 81;
    while (--i >= 0) {
        mLtL[i] = 0.0;
    }
    for (i = 0; i < HOMO_COUNT; ++i) {
        x = (to[i].x - cmx) * smx;
        y = (to[i].y - cmy) * smy;
        X = (from[i].x - cMx) * sMx;
        Y = (from[i].y - cMy) * sMy;
        mLtL[0] += X * X;
        mLtL[1] += X * Y;
        mLtL[2] += X;
        mLtL[6] += X * -x * X;
        mLtL[7] += X * -x * Y;
        mLtL[8] += X * -x;
        mLtL[10] += Y * Y;
        mLtL[11] += Y;
        mLtL[15] += Y * -x * X;
        mLtL[16] += Y * -x * Y;
        mLtL[17] += Y * -x;
        mLtL[20] += 1.0;
        mLtL[24] += -x * X;
        mLtL[25] += -x * Y;
        mLtL[26] += -x;
        mLtL[30] += X * X;
        mLtL[31] += X * Y;
        mLtL[32] += X;
        mLtL[33] += X * -y * X;
        mLtL[34] += X * -y * Y;
        mLtL[35] += X * -y;
        mLtL[40] += Y * Y;
        mLtL[41] += Y;
        mLtL[42] += Y * -y * X;
        mLtL[43] += Y * -y * Y;
        mLtL[44] += Y * -y;
        mLtL[50] += 1.0;
        mLtL[51] += -y * X;
        mLtL[52] += -y * Y;
        mLtL[53] += -y;
        mLtL[60] += -x * X * -x * X + -y * X * -y * X;
        mLtL[61] += -x * X * -x * Y + -y * X * -y * Y;
        mLtL[62] += -x * X * -x + -y * X * -y;
        mLtL[70] += -x * Y * -x * Y + -y * Y * -y * Y;
        mLtL[71] += -x * Y * -x + -y * Y * -y;
        mLtL[80] += -x * -x + -y * -y;
    }
    //
    // symmetry
    for (i = 0; i < 9; ++i) {
        for (j = 0; j < i; ++j) {
            mLtL[i * 9 + j] = mLtL[j * 9 + i];
        }
    }
    eigenVV(mLtL, Evec);
    md[0] = Evec[72];
    md[1] = Evec[73];
    md[2] = Evec[74];
    md[3] = Evec[75];
    md[4] = Evec[76];
    md[5] = Evec[77];
    md[6] = Evec[78];
    md[7] = Evec[79];
    md[8] = Evec[80];
    // denormalize
    md = Matrix.multiply_3x3(T1, md);
    md = Matrix.multiply_3x3(md, T0);
    // set bottom right to 1.0
    x = 1.0 / md[8];
    md[0] *= x;
    md[1] *= x;
    md[2] *= x;
    md[3] *= x;
    md[4] *= x;
    md[5] *= x;
    md[6] *= x;
    md[7] *= x;
    md[8] = 1.0;
    return md;
}
var N = 9;
function eigenVV(A, vects) {
    var a_mt = Matrix.create(N, N);
    var w_mt = Matrix.create(1, N);
    for (var i = 0; i < A.length; i++) {
        a_mt[i] = A[i];
    }
    JacobiImpl(a_mt, N, w_mt, vects, N, N);
}
function JacobiImpl(A, astep, W, V, vstep, n) {
    var eps = util_1.EPSILON;
    var i = 0;
    var j = 0;
    var k = 0;
    var m = 0;
    var l = 0;
    var idx = 0;
    var _in = 0;
    var _in2 = 0;
    var iters = 0;
    var max_iter = n * n * 30;
    var mv = 0.0;
    var val = 0.0;
    var p = 0.0;
    var y = 0.0;
    var t = 0.0;
    var s = 0.0;
    var c = 0.0;
    var a0 = 0.0;
    var b0 = 0.0;
    var indR_buff = Matrix.create(n);
    var indC_buff = Matrix.create(n);
    var indR = indR_buff;
    var indC = indC_buff;
    if (V) {
        for (; i < n; i++) {
            k = i * vstep;
            for (j = 0; j < n; j++) {
                V[k + j] = 0.0;
            }
            V[k + i] = 1.0;
        }
    }
    for (k = 0; k < n; k++) {
        W[k] = A[(astep + 1) * k];
        if (k < n - 1) {
            for (m = k + 1, mv = Math.abs(A[astep * k + m]), i = k + 2; i < n; i++) {
                val = Math.abs(A[astep * k + i]);
                if (mv < val) {
                    mv = val;
                    m = i;
                }
            }
            indR[k] = m;
        }
        if (k > 0) {
            for (m = 0, mv = Math.abs(A[k]), i = 1; i < k; i++) {
                val = Math.abs(A[astep * i + k]);
                if (mv < val) {
                    mv = val;
                    m = i;
                }
            }
            indC[k] = m;
        }
    }
    if (n > 1) {
        for (; iters < max_iter; iters++) {
            // find index (k,l) of pivot p
            for (k = 0, mv = Math.abs(A[indR[0]]), i = 1; i < n - 1; i++) {
                val = Math.abs(A[astep * i + indR[i]]);
                if (mv < val) {
                    mv = val;
                    k = i;
                }
            }
            l = indR[k];
            for (i = 1; i < n; i++) {
                val = Math.abs(A[astep * indC[i] + i]);
                if (mv < val) {
                    mv = val;
                    k = indC[i];
                    l = i;
                }
            }
            p = A[astep * k + l];
            if (Math.abs(p) <= eps) {
                break;
            }
            y = (W[l] - W[k]) * 0.5;
            t = Math.abs(y) + (0, util_1.hypot)(p, y);
            s = (0, util_1.hypot)(p, t);
            c = t / s;
            s = p / s;
            t = (p / t) * p;
            if (y < 0) {
                s = -s;
                t = -t;
            }
            A[astep * k + l] = 0;
            W[k] -= t;
            W[l] += t;
            // rotate rows and columns k and l
            for (i = 0; i < k; i++) {
                _in = (astep * i + k);
                _in2 = (astep * i + l);
                a0 = A[_in];
                b0 = A[_in2];
                A[_in] = a0 * c - b0 * s;
                A[_in2] = a0 * s + b0 * c;
            }
            for (i = (k + 1); i < l; i++) {
                _in = (astep * k + i);
                _in2 = (astep * i + l);
                a0 = A[_in];
                b0 = A[_in2];
                A[_in] = a0 * c - b0 * s;
                A[_in2] = a0 * s + b0 * c;
            }
            i = l + 1;
            _in = (astep * k + i);
            _in2 = (astep * l + i);
            for (; i < n; i++, _in++, _in2++) {
                a0 = A[_in];
                b0 = A[_in2];
                A[_in] = a0 * c - b0 * s;
                A[_in2] = a0 * s + b0 * c;
            }
            // rotate eigenvectors
            if (V) {
                _in = vstep * k;
                _in2 = vstep * l;
                for (i = 0; i < n; i++, _in++, _in2++) {
                    a0 = V[_in];
                    b0 = V[_in2];
                    V[_in] = a0 * c - b0 * s;
                    V[_in2] = a0 * s + b0 * c;
                }
            }
            for (j = 0; j < 2; j++) {
                idx = j === 0 ? k : l;
                if (idx < n - 1) {
                    for (m = idx + 1, mv = Math.abs(A[astep * idx + m]), i = idx + 2; i < n; i++) {
                        val = Math.abs(A[astep * idx + i]);
                        if (mv < val) {
                            mv = val;
                            m = i;
                        }
                    }
                    indR[idx] = m;
                }
                if (idx > 0) {
                    for (m = 0, mv = Math.abs(A[idx]), i = 1; i < idx; i++) {
                        val = Math.abs(A[astep * i + idx]);
                        if (mv < val) {
                            mv = val;
                            m = i;
                        }
                    }
                    indC[idx] = m;
                }
            }
        }
    }
    // sort eigenvalues & eigenvectors
    for (k = 0; k < n - 1; k++) {
        m = k;
        for (i = k + 1; i < n; i++) {
            if (W[m] < W[i]) {
                m = i;
            }
        }
        if (k !== m) {
            (0, util_1.swap)(W, m, k, mv);
            if (V) {
                for (i = 0; i < n; i++) {
                    (0, util_1.swap)(V, vstep * m + i, vstep * k + i, mv);
                }
            }
        }
    }
}
//# sourceMappingURL=homography.js.map